import { createFileRoute } from "@tanstack/react-router";
import { NenhumaRespostaEscolhida } from "@/pages/admin/Resposta";

export const Route = createFileRoute("/admin/formularios/$tipo/")({
  component: NenhumaRespostaEscolhida,
});
